import React from 'react';
import { animated, useTransition } from '@react-spring/web';
import Tooltip from '@pushpay/tooltip';
import { NavigationItemLabel } from './navigation-item-label';
import { useNavigationStyles } from './navigation-styles';
export function NavigationItem({
  icon: Icon,
  indicatorIcon: IndicatorIcon,
  indicatorIconTooltip,
  label,
  classes: classesProp,
  displayStyle
}) {
  const classes = useNavigationStyles(classesProp);
  const indicatorIcon = typeof IndicatorIcon === 'function' ? /*#__PURE__*/React.createElement(IndicatorIcon, {
    title: indicatorIconTooltip
  }) : IndicatorIcon;
  const transition = useTransition(displayStyle === 'collapsed', {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.iconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon
  }), transition((style, visible) => visible && /*#__PURE__*/React.createElement(animated.div, {
    className: classes.collapsedIndicatorIcon,
    style: style
  }, indicatorIcon))), /*#__PURE__*/React.createElement(NavigationItemLabel, {
    displayStyle: displayStyle
  }, label, indicatorIcon && displayStyle === 'expanded' && (indicatorIconTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    className: classes.expandedIndicatorIcon,
    content: indicatorIconTooltip,
    placement: "top"
  }, indicatorIcon) : /*#__PURE__*/React.createElement("span", {
    className: classes.expandedIndicatorIcon
  }, indicatorIcon))));
}